const Tags = () => import('@/pages/tags/Tags.vue');

export default [
  // 标签管理
  {
    path: '/tag/manage',
    name: 'tagManage',
    component: Tags,
  },
]